export const getIdsPayloadString = (arr: string[]) => {
  let str = '';
  arr.forEach((id, index) => (str += `${id}${index < arr.length - 1 ? ',' : ''}`));

  return str;
};
